import React from 'react';
import { Link } from 'react-router-dom';

const ServiceSection = () => {
  return (
    <section className="service-section light-bg mx-60 border-shape-top">
      <div className="auto-container">
        <div className="row">
          {/* Left Image Column */}
          <div className="col-lg-6">
            <div className="image-block">
              <div className="image">
                <img src="/images/image-7.png" alt="Main Service" />
                {/* <img src="/images/resource/image-7.jpg" alt="Main Service" /> */}
              </div>
              <div className="text-end">
                <div className="image-two img_hover_1">
                  <img src="/images/resource/image-366.png" alt="Secondary Service" />
                </div>
              </div>
              <div className="text-one">Forest-to-Table</div>
              <div className="text-two">Dining Experience</div>
            </div>
          </div>

          {/* Right Content Column */}
          <div className="col-lg-6">
            <div className="content-block">
              <div className="title-box">
                <div className="sub-title">eat & drink</div>
                <h2 className="sec-title small">
                  Savor fresh, locally sourced <br /> delicacies amidst the forest
                </h2>
              </div>
              {/* <div className="time">Open Daily : 7.30 am - 11.00 pm</div> */}
              <div className="link-btn">
                <Link to="/contact" className="theme-btn btn-style-two">
                  <span>Contact Us</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
